import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react';
import { useUserInfo } from '../../providers/userProvider'
import { ERR_TITLE_PREVIOUS,ERR_DESC_PREVIOUS,ERR_TITLE_ACCESS} from '../../utils/errorLiterals';

export const ProtectedRoute = ({ component: Component, validUser, validPreviousPage, ...rest }) => {
    const userInfo = useUserInfo();
    const [userType, setUserType] = useState();
    const errorDesc = userInfo && userInfo.userID + ' ' + userInfo.userType
    const errorUrl =  window.location.href;
    useEffect(() => {
        if (userInfo) {
            setUserType(userInfo.userType);
        }
    }, [userInfo])
    return (
        <SecureRoute {...rest} render={props => {
            let state = props.location && props.location.state ? props.location.state : { previous: '' };
            if (!userType) {
                return null;
            } else if (userType && (!validUser || validUser.includes(userType))) {
                if (!validPreviousPage || validPreviousPage.includes(state.previous)) {
                    return <Component {...props} />
                } else {
                    return <Redirect
                                to={{
                                pathname: '/error',
                                state: {errorTitle: ERR_TITLE_PREVIOUS,
                                        errorDescription: ERR_DESC_PREVIOUS, 
                                        errorUrl: errorUrl,
                                        errorUser: userInfo? userInfo.userID : ''}
                                }}
                            />
                }

            } else {
                return <Redirect
                            to={{
                            pathname: '/error',
                            state: {errorTitle: ERR_TITLE_ACCESS, 
                                    errorDescription: errorDesc, 
                                    errorUrl:errorUrl,
                                    errorUser: userInfo? userInfo.userID : ''}
                            }}
                        />
            }
        }
        } />
    )
}

